import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    text: {
        name: () => '名称',
        required: () => true,
    },

    type: {
        name: () => '类型',
        required: () => true,
    },
})
